const colors = {
  primaryBlue: {
    surface: '#f3fbff',
    5: '#F8FDFF',
    10: '#EBFCFF',
    15: '#DEF9FF',
    20: '#B7F2FF',
    30: '#82E8FF',
    40: '#2BC2E1', // main
    50: '#12b7e3',
    60: '#1a9fbe',
    70: '#357B89', 
    80: '#026478',
    90: '#416777',
  },
  yellow: {
    background: '#fdf5e6',
    5: '#FFFAEA',
    10: '#f9eed7',
    15: '#f6e3b8',
    20: '#FFD55B',
    30: '#FFBE00',
    40: '#FFAE00',
    50: '#f29a00',
  },
  green: {
    background: '#edf7ef',
    10: '#e0f5e6',
    15: '#d2efda',
    20: '#c0e7c2',
    30: '#b3d97f',
    40: '#95b35d',
    50: '#7bb879',
    60: '#3db778',
    65: '#24a863',
    70: '#2c8c58',
    80: '#0e6b3c',
  },
  grayScale: {
    0: '#ffffff',
    3: '#f9fafb',
    6: '#f5f6f7',
    10: '#F0F1F2',
    20: '#e3e5e8', // line
    30: '#d6d7da', // disabled box
    40: '#c8c9cc', // background
    50: '#BCBCBC', // disabled text
    60: '#929292',
    70: '#676767', // sub text
    80: '#404040', // main text
    90: '#17171B', // sub text
  },
  other: {
    mainBackground: '#ffffff',
    secondBackground: '#f8fbff',
    red10: '#ff0f0f',
    red5: '#f6b8bc',
  },
};

const typography = {
  head: {
    regular44: { fontSize: '44px', lineHeight: '130%', fontWeight: 400 },
    bold32: { fontSize: '32px', lineHeight: '28px', fontWeight: 700 },
    regular32: { fontSize: '32px', lineHeight: '140%', fontWeight: 400 },
    bold28: { fontSize: '28px', lineHeight: '150%', fontWeight: 700 },
    semiBold24: { fontSize: '24px', lineHeight: '120%', fontWeight: 600 },
    semiBold20: { fontSize: '20px', lineHeight: '150%', fontWeight: 600 },
    bold16: { fontSize: '16px', lineHeight: '120%', fontWeight: 700 },
  },
  contents: {
    medium28: { fontSize: '28px', lineHeight: '130%', fontWeight: 500 },
    regular24: { fontSize: '24px', lineHeight: '150%', fontWeight: 400 },
    medium24: { fontSize: '24px', lineHeight: '150%', fontWeight: 500 },
    regular20: { fontSize: '20px', lineHeight: '150%', fontWeight: 400 },
    medium20: { fontSize: '20px', lineHeight: '150%', fontWeight: 500 },
    regular16: { fontSize: '16px', lineHeight: '130%', fontWeight: 400 },
  },
  button: {
    bold24: { fontSize: '24px', lineHeight: '150%', fontWeight: 700 },
    semiBold20: { fontSize: '20px', lineHeight: '150%', fontWeight: 600 },
    regular20: { fontSize: '20px', lineHeight: '150%', fontWeight: 400 },
    medium20: { fontSize: '20px', lineHeight: '150%', fontWeight: 500 },
    medium24: { fontSize: '24px', lineHeight: '125%', fontWeight: 500 },
  },
  chip: {
    medium16: { fontSize: '16px', lineHeight: '150%', fontWeight: 500 },
    semiBold16: { fontSize: '16px', lineHeight: '150%', fontWeight: 600 },
  },
  caption: {
    bold16: { fontSize: '16px', lineHeight: '120%', fontWeight: 700 },
    regular16: { fontSize: '16px', lineHeight: '20px', fontWeight: 400 },
    regular16Long: { fontSize: '16px', lineHeight: '150%', fontWeight: 400 },
    bold14: { fontSize: '14px', lineHeight: '120%', fontWeight: 700 },
    regular14: { fontSize: '14px', lineHeight: '130%', fontWeight: 400 },
    m3: { fontSize: '14px', lineHeight: '150%', fontWeight: 500 },
  },
  family: "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};

const baseTheme = {
  colors,
  typography,
};

export type ThemeType = typeof baseTheme;

export const theme: ThemeType = baseTheme;

export default theme;

